import { useRef } from "react";
import { Link, useLocation } from "react-router-dom";

const SubTabItem = ({
  pathname,
  tab,
  color,
}: {
  pathname: string;
  tab: any;
  color: string | null;
}) => {
  // url이 /management/seminar_weekly일 때 /management/seminar도 하이라이트 되는 문제 해결
  const seminarException =
    pathname.includes("/management/seminar_weekly") && tab.url === "/management/seminar";

  // url이 /recruit이거나 /recruit/chicruiting일 때 치과위생사가 하이라이트 되도록 함
  const recruitException =
    (pathname === "/recruit" && tab.url === "/recruit/hygienist") ||
    (pathname.includes("/recruit/chicruiting") && tab.url === "/recruit/hygienist");

  const location = useLocation();
  const urlParam = new URLSearchParams(location.search);
  const cateParam = urlParam.get("cate");
  const lastCateRef = useRef<number>(0);

  if (cateParam !== null) {
    lastCateRef.current = parseInt(cateParam);
  }

  const board = lastCateRef.current;

  // 서브탭 URL 매칭: pathname에 tab.url이 포함되거나, 글쓰기/수정 경로에서 tab.value가 포함된 경우
  const segments = pathname.split("/");
  const isSubTabActive =
    (pathname.includes(tab.url) && !seminarException) ||
    recruitException ||
    (tab.value && segments.includes(tab.value));

  const LinkClassName = () => {
    const className = "text-[14px] py-[9px] flex items-center ";

    if (color) {
      if (isSubTabActive) {
        return (
          className +
          `text-${color} text-opacity-100 font-bold border-b-[3px] border-solid border-${color}`
        );
      } else {
        return className + `text-${color} text-opacity-50 hover:text-opacity-100`;
      }
    } else if (board === tab.cate_cd) {
      return (
        className +
        "text-medi-color-purple-600 border-b-[3px] border-solid border-medi-color-purple-600"
      );
    } else {
      if (isSubTabActive) {
        return (
          className +
          "text-medi-color-purple-600 font-medium border-b-[3px] border-solid border-medi-color-purple-600"
        );
      } else {
        return className + "text-gray-600 hover:text-medi-color-purple-600";
      }
    }
  };

  return (
    <>
      <Link className={LinkClassName()} to={tab.url}>
        {tab.cate_name}
      </Link>
    </>
  );
};

export default SubTabItem;
